<script setup lang="ts">
  import { computed, useAttrs } from "vue";
  import type { HTMLAttributes } from "vue";
  import { AlertDialogCancel, type AlertDialogCancelProps } from "reka-ui";
  import { cn } from "@/lib/utils";
  import { buttonVariants } from "@/components/ui/button";

  const props = defineProps<AlertDialogCancelProps & { class?: HTMLAttributes["class"] }>();
  const emit = defineEmits(["click"]);
  const attrs = useAttrs();
  const forwarded = computed(() => ({ ...props, ...attrs }));
</script>

<template>
  <AlertDialogCancel
    v-bind="forwarded"
    :class="cn(buttonVariants({ variant: 'outline' }), 'mt-2 sm:mt-0', props.class)"
    @click="emit('click', $event)">
    <slot />
  </AlertDialogCancel>
</template>
